import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/portfolio-gallery/components/PortfolioInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/common/Header.tsx");
